import { useState } from 'react';

import { ApiClient, ApiError, sessionTokenStore } from './api/client';
import { LookupScreen } from './screens/LookupScreen';
import { InstallersScreen } from './screens/InstallersScreen';
import { PricingScreen } from './screens/PricingScreen';
import { SettlementsScreen } from './screens/SettlementsScreen';
import { InstallationsScreen } from './screens/InstallationsScreen';

const api = new ApiClient(sessionTokenStore);

type Tab = 'lookup' | 'installations' | 'settlements' | 'installers' | 'pricing';

export function App() {
  const [loggedIn, setLoggedIn] = useState(api.isLoggedIn);
  const [tab, setTab] = useState<Tab>('lookup');

  if (!loggedIn) {
    return <Login onDone={() => setLoggedIn(true)} />;
  }

  const signOut = () => {
    api.logout();
    setLoggedIn(false);
  };

  return (
    <div className="app">
      <header className="topbar">
        <nav>
          <button className={tab === 'lookup' ? 'active' : ''} onClick={() => setTab('lookup')}>
            جستجوی سریع
          </button>
          <button
            className={tab === 'installations' ? 'active' : ''}
            onClick={() => setTab('installations')}
          >
            نصب‌ها
          </button>
          <button
            className={tab === 'settlements' ? 'active' : ''}
            onClick={() => setTab('settlements')}
          >
            تسویه‌ها
          </button>
          <button
            className={tab === 'installers' ? 'active' : ''}
            onClick={() => setTab('installers')}
          >
            نصاب‌ها
          </button>
          <button className={tab === 'pricing' ? 'active' : ''} onClick={() => setTab('pricing')}>
            قیمت‌ها
          </button>
        </nav>
        <button onClick={signOut}>خروج</button>
      </header>

      {/* Remounting on tab change keeps each screen's state honest — a stale
          lookup result must not survive a trip to another tab and back. */}
      {tab === 'lookup' && <LookupScreen key="lookup" api={api} onAuthLost={signOut} />}
      {tab === 'installations' && (
        <InstallationsScreen key="installations" api={api} onAuthLost={signOut} />
      )}
      {tab === 'settlements' && <SettlementsScreen key="settlements" api={api} onAuthLost={signOut} />}
      {tab === 'installers' && <InstallersScreen key="installers" api={api} onAuthLost={signOut} />}
      {tab === 'pricing' && <PricingScreen key="pricing" api={api} onAuthLost={signOut} />}
    </div>
  );
}

function Login({ onDone }: { onDone: () => void }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await api.login(username, password);
      onDone();
    } catch (err) {
      /* The server returns one message for every failure mode on purpose; do not
       * try to be more specific here than it was. */
      setError(err instanceof ApiError ? err.message : 'ورود ناموفق بود');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="app">
      <form className="card login" onSubmit={submit}>
        <h2 style={{ marginTop: 0 }}>پنل اشتراک اوتلندر</h2>
        {error && <div className="alert error">{error}</div>}
        <label>
          <span>نام کاربری</span>
          <input value={username} onChange={(e) => setUsername(e.target.value)} autoFocus dir="ltr" />
        </label>
        <label>
          <span>رمز عبور</span>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            dir="ltr"
          />
        </label>
        <button className="primary" style={{ width: '100%' }} disabled={busy || !username || !password}>
          {busy ? 'در حال ورود…' : 'ورود'}
        </button>
      </form>
    </div>
  );
}
